export const getReconciliation = async () => {
    const getReconciliationUrl = routable.getRoute('getReconciliation');
    try {
        const getReconciliationResponse = await fetch(getReconciliationUrl, {
            method: 'GET',
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
            },
        });

        if (!getReconciliationResponse.ok) {
            const error = await getReconciliationResponse.json();
            //@ts-ignore
            swal({
                text: error.message,
                cancel: false,
                confirm: true,
                button: {
                    text: i18next.t('button.ok.text'),
                    value: true,
                    visible: true,
                    className: 'btn btn-secondary',
                },
            });
            return error.message;
        }

        const { data } = await getReconciliationResponse.json();

        return data;
    } catch (error) {
        console.error(error.message);
    }
};
